<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog" role="document">
      <div class="modal-content radius-8 px-4">
        <div class="text-center">
          <h3 class="modal-title mb-8" id="medalReminderModalLabel">{{ customer.translations.medal_reminder_title }}</h3>
          <p class="modal-text">{{ customer.translations.medal_reminder_message }}</p>
          <p class="modal-text">{{ customer.translations.medal_reminder_question }}</p>

          <div class="d-flex flex-column justify-content-center max-280 mt-2">
            <button
              class="btn primary-btn px-1 d-flex align-items-center justify-content-center"
              @click="addMedals"
            >
              {{ customer.translations.add_medals }}
            </button>

            <button
              type="button"
              class="btn modal-secondary-btn mt-2"
              @click="continueWithoutMedals"
              aria-label="Close"
            >
              {{ customer.translations.continue_without_medals }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      customer: {
        type: Object,
        required: true
      }
    },
    methods: {
      addMedals() {
        this.$emit('add-medals');
      },
      continueWithoutMedals() {
        this.$emit('continue-without-medals');
      }
    }
  };
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }

  .modal-dialog {
    max-width: 400px;
    width: 100%;
  }

  .modal-content {
    background: white;
    border-radius: 8px;
    padding: 2rem;
  }

  .modal-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .modal-text {
    font-size: 1rem;
    color: #343a40;
    margin-bottom: 0.5rem;
  }

  .max-280 {
    max-width: 280px;
    margin: 0 auto;
  }

  .btn {
    padding: 0.75rem 1rem;
    border-radius: 8px;
    font-weight: 600;
  }

  .primary-btn {
    background-color: #C8102F;
    color: white;
    border: none;
  }

  .primary-btn:hover {
    background-color: #a00d25;
  }

  .modal-secondary-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    display: block;
    width: 100%;
  }

  .modal-secondary-btn:hover {
    background-color: #5a6268;
  }
</style>
